export const DELIVERY_CHALLAN_DOCUMENT_LABELS = {
  delivery_challan: 'Delivery Challan',
  delivery_challan_tax_invoice: 'Delivery Challan Cum Tax Invoice',
  delivery_challan_einvoice: 'Delivery Challan Cum E-Invoice',
  delivery_challan_eway_bill_einvoice: 'Delivery Challan + E-Way Bill + E-Invoice',
  delivery_challan_eway_bill: 'Delivery Challan With E-Way Bill',
};

export const getDeliveryChallanDocumentLabel = (documentType) =>
  DELIVERY_CHALLAN_DOCUMENT_LABELS[documentType] || DELIVERY_CHALLAN_DOCUMENT_LABELS.delivery_challan;
